/** @format */
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { surveyService } from '../../Services/survey.services';

const AddSurvey = ({ onSuccess, setResultModal, disabled }) => {
	const { t: translator } = useTranslation();
	const { register, handleSubmit, errors } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});

	const onSubmit = data => {
		surveyService
			.create(data)
			.then(res => {
				onSuccess();
				setResultModal({
					show: true,
					title: translator('Survey-Add-SuccessModal-Title'),
					text: translator(res.data.message),
					btnClass: 'btn btn-primary',
				});
			})
			.catch(err => console.log(err));
	};

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className='p-4'
			style={{ border: '1px solid lightgray' }}>
			<h5 className='mb-4 text-center font-weight-bold'>
				{translator('Survey-AddNew')}
			</h5>

			<fieldset className='scheduler-border'>
				<div className='form-group'>
					<label>{translator('Survey-Name')}</label>
					<input
						type='text'
						className='form-control'
						ref={register({ required: true, maxLength: 100 })}
						name='name'
						disabled={disabled}
					/>
					{errors.name && errors.name.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
					{errors.name && errors.name.type === 'maxLength' && (
						<p className='text-danger'>{translator('ValidationMsg-MaxLength100')}</p>
					)}
				</div>

				<div className='form-group'>
					<label>{translator('Survey-Description')}</label>
					<textarea
						className='form-control'
						ref={register({ maxLength: 500 })}
						name='description'
						rows={3}
						disabled={disabled}
					/>
					{errors.description && errors.description.type === 'maxLength' && (
						<p className='text-danger'>{translator('ValidationMsg-MaxLength500')}</p>
					)}
				</div>

				<div className='form-group'>
					<label>{translator('Survey-Content')}</label>
					<input
						type='text'
						className='form-control'
						ref={register({
							required: true,
							pattern: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i,
						})}
						name='content'
						disabled={disabled}
					/>
					{errors.content && errors.content.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
					{errors.content && errors.content.type === 'pattern' && (
						<p className='text-danger'>{translator('ValidationMsg-InvalidUrl')}</p>
					)}
				</div>

				<div className='form-row'>
					<div className='form-group col-6'>
						<label>{translator('Survey-ValidFrom')}</label>
						<input
							type='date'
							className='form-control'
							ref={register({ required: true })}
							name='validFrom'
							disabled={disabled}
						/>
						{errors.validFrom && errors.validFrom.type === 'required' && (
							<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
						)}
					</div>

					<div className='form-group col-6'>
						<label>{translator('Survey-ValidTo')}</label>
						<input
							type='date'
							className='form-control'
							ref={register({ required: true })}
							name='validTo'
							disabled={disabled}
						/>
						{errors.validTo && errors.validTo.type === 'required' && (
							<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
						)}
					</div>
				</div>
			</fieldset>

			<div className='d-flex justify-content-end mt-2'>
				<button className='btn btn-primary' type='submit' disabled={disabled}>
					{translator('Btn-Save')}
				</button>
			</div>
		</form>
	);
};

export default AddSurvey;
